import React, { useState } from "react";

import Sidebar from '../components/AdminSideBar'
import Header from "../components/AdminHeader";

const AdminLayout = ({children}) => {
     const [sidebarOpen, setSidebarOpen] = useState(false);
   

     return (
       <div className="flex h-screen bg2 overflow-hidden"  >
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}  />
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-200 bg-opacity-40 z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

  

      {/* /* Main Content */ }
        <div
          className="flex-1 flex flex-col overflow-hidden ">
            <span className="">
         <Header  sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
            </span>
        {/* Content Area */}
        <main className="flex-1 overflow-y-auto py-5 px-5 bg-gray-100">{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
